import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
import { isAnalyticsGranted } from '../utils/cookieConsent';

const usePageAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsGranted()) {
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
};

export default usePageAnalytics;
